import { ExternalLink } from "@/components/ExternalLink";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
import { createEnum } from "@/lib/utils/createEnum";
import {
  buildSharedPortfolioColumns,
  withPortfolioActions,
} from "@/lib/portfolios/tableColumns";

export type C3Portfolio = {
  id: number;
  client: string;
  vehicle: string | null;

  account_name: string;
  short_account_name: string | null;

  name: string;
  currency: string;
  reporting_currency: string;

  bank_name: string | null;
  account_type: string;

  investment_type: string | null;
  contract_name: string | null;

  code: string;

  has_pdf_bank_page: boolean | null;
  display_performance_report: boolean | null;

  collateral: boolean | null;

  has_transactions?: boolean;

  vehicle_index: number | null;
};
export const c3PortfolioFields = createEnum<C3Portfolio>();

export const columnVisibilityInit: Record<string, boolean> = {};

export const porfolios_columns: ColumnDef<C3Portfolio>[] = withPortfolioActions(
  buildSharedPortfolioColumns<C3Portfolio, unknown>({
    fields: {
      id: c3PortfolioFields.id,
      client: c3PortfolioFields.client,
      vehicle: c3PortfolioFields.vehicle,
      reporting_currency: c3PortfolioFields.reporting_currency,
      account_name: c3PortfolioFields.account_name,
      name: c3PortfolioFields.name,
      account_type: c3PortfolioFields.account_type,
      currency: c3PortfolioFields.currency,
      code: c3PortfolioFields.code,
      bank_name: c3PortfolioFields.bank_name,
    },
  }),
  [
    {
      id: "actions",
      cell: ({ row }) => {
        const hasTransactions = row.original.has_transactions;

        return (
          <div className="flex gap-3 justify-end">
            <ExternalLink
              href={toWorkspacePath(
                `/admin/${Clients.C3}/${Tables.C3_TRANSACTIONS}`,
              )}
              queryParams={{
                c3_portfolios_id_equal: row.getValue(c3PortfolioFields.id),
              }}
              className={`text-xs ${
                !hasTransactions ? "invisible pointer-events-none" : ""
              }`}
              underline="hover"
            >
              Transactions
            </ExternalLink>
            <Link
              href={`${window.location.pathname}/${row.getValue(c3PortfolioFields.id)}`}
              className="text-xs"
              underline="hover"
            >
              {i18n.t("actions.edit")}
            </Link>
          </div>
        );
      },
    },
  ],
);
